import { createContext, useContext, useEffect, useMemo, useState } from "react";
import useCustomer from "V2.0/hooks/useCustomer";

import * as projectService from "V2.0/services/projectService";

const AccountContext = createContext(null);

export const useAccountContext = () => {
  return useContext(AccountContext);
};

export default function AccountProvider({ children }) {
  const { companyId, ...restCustomer } = useCustomer();
  const [account, setAccount] = useState({
    workspaces: [],
    company: null,
    isAccountLoading: true,
  });

  async function fetchWorkspaces() {
    try {
      const response = await projectService.getAllProjectsForCustomerId();

      if (response.status === 200) {
        setAccount((prevState) => {
          return {
            ...prevState,
            workspaces: response.data,
            company: response.data[0]?.company || prevState.company,
            isAccountLoading: false,
          };
        });
      }
    } catch (e) {
      setAccount((prevState) => {
        return {
          ...prevState,
          isAccountLoading: false,
        };
      });
    }
  }

  useEffect(() => {
    fetchWorkspaces();
  }, []);

  function syncWorkspace(workspace) {
    setAccount((prevState) => {
      const { workspaces } = prevState;

      const updatedWorkspaces = workspaces.map((_workspace) => {
        if (_workspace._id === workspace._id) {
          return workspace;
        }
        return _workspace;
      });

      return {
        ...prevState,
        workspaces: updatedWorkspaces,
      };
    });
  }

  const value = useMemo(() => {
    return {
      workspaces: account.workspaces,
      company: account.company,
      isAccountLoading: account.isAccountLoading,
      syncWorkspace,
      fetchWorkspaces,
      customer: restCustomer,
    };
  }, [account, restCustomer]);

  return (
    <AccountContext.Provider value={value}>{children}</AccountContext.Provider>
  );
}
